import React, { useState, useEffect } from 'react';
import { Card, TextField, Button, Page } from '@shopify/polaris';
import { config } from '../constants';
import { authenticatedFetch } from '../utils/api';

export default function Help() {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [storeDomain, setStoreDomain] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const shopFromUrl = params.get('shop');
    if (shopFromUrl) {
      setStoreDomain(shopFromUrl);
    }
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImageFile(null);
      setImagePreview(null);
    }
  };

  const handleSend = async () => {
    setSending(true);
    setSuccess(false);
    setError('');
    let imageBase64 = null;
    if (imageFile) {
      imageBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(imageFile);
      });
    }
    try {
      const res = await authenticatedFetch('https://chatbot-proxy.azure-api.net/api/support-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subject, body, storeDomain, image: imageBase64, imageName: imageFile?.name, imageType: imageFile?.type })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess(true);
        setSubject('');
        setBody('');
        setImageFile(null);
        setImagePreview(null);
      } else {
        setError(data.error || 'Failed to send email');
      }
    } catch (e) {
      setError('Failed to send email');
    }
    setSending(false);
  };

  return (
    <Page>
      <div style={{ marginTop: 8 }}>
        <Card sectioned title="Contact Support">
          <p>For any help or to report an issue, email: <b>{config.SUPPORT_EMAIL}</b></p>
        </Card>
        <div style={{ display: 'flex', alignItems: 'center', margin: '24px 0' }}>
          <div style={{ flex: 1, height: 1, background: '#e1e3e5' }} />
          <span style={{ margin: '0 16px', color: '#888', fontWeight: 600, fontSize: 16 }}>OR</span>
          <div style={{ flex: 1, height: 1, background: '#e1e3e5' }} />
        </div>
        <Card sectioned title="Send a Message to Developer">
          <TextField
            label="Subject"
            value={subject}
            onChange={setSubject}
            autoComplete="off"
            disabled={sending}
            required
            style={{ marginBottom: 16 }}
          />
          <TextField
            label="Body"
            value={body}
            onChange={setBody}
            multiline={6}
            autoComplete="off"
            disabled={sending}
            required
            style={{ marginBottom: 24 }}
          />
          <div style={{ marginBottom: 8 }} />
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <input
              id="help-file-input"
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              disabled={sending}
              style={{ display: 'none' }}
            />
            <Button
              onClick={() => document.getElementById('help-file-input').click()}
              disabled={sending}
              style={{ marginRight: 12 }}
            >
              Choose File
            </Button>
            <span style={{ display: 'inline-block', width: 18 }} />
            <span style={{ color: '#555', fontSize: 15 }}>
              {imageFile ? imageFile.name : 'No file chosen'}
            </span>
          </div>
          {imagePreview && (
            <div style={{ marginBottom: 16 }}>
              <img src={imagePreview} alt="Screenshot preview" style={{ maxWidth: 250, maxHeight: 150, border: '1px solid #ccc', borderRadius: 4 }} />
            </div>
          )}
          <div style={{ marginBottom: 16 }} />
          <Button
            variant="primary"
            onClick={handleSend}
            loading={sending}
            disabled={sending || !subject.trim() || !body.trim()}
            style={{ marginTop: 16 }}
          >
            Send Email
          </Button>
          {success && <div style={{ color: 'green', marginTop: 12 }}>Message sent successfully!</div>}
          {error && <div style={{ color: 'red', marginTop: 12 }}>{error}</div>}
        </Card>
      </div>
    </Page>
  );
}
